import { useQuery } from '@tanstack/react-query'
import { api } from '../../utils/apiClient'
import type { DrawerProduct } from '../../utils/productDisplayUtils'
import { queryKeys } from './keys'

interface DrawerProductAttributes {
  name: string
  code: string
  sort?: number | null
  access_url?: string | null
  product_tag?: string | null
  is_knowledge_hub?: boolean
  is_research_hub?: boolean
  is_instructor_hub?: boolean
  is_prework?: boolean
  is_proxima?: boolean
  expiration_date?: string | null
  has_renewable_subscription?: boolean
}

function parseProducts(response: { data?: { data?: Array<{ id: string; attributes: DrawerProductAttributes }> } }): DrawerProduct[] {
  return (response.data?.data ?? []).map(({ id, attributes }) => ({
    id,
    name: attributes.name,
    code: attributes.code,
    sort: attributes.sort,
    accessUrl: attributes.access_url,
    productTag: attributes.product_tag,
    isKnowledgeHub: attributes.is_knowledge_hub,
    isResearchHub: attributes.is_research_hub,
    isInstructorHub: attributes.is_instructor_hub,
    isPrework: attributes.is_prework,
    isProxima: attributes.is_proxima,
    expirationDate: attributes.expiration_date,
    hasRenewableSubscription: attributes.has_renewable_subscription,
  }))
}

export function useProductDrawerQuery(
  userId?: string,
  workspaceId?: string | number,
  enabled = true
) {
  return useQuery({
    queryKey: queryKeys.productDrawer.forUser(userId ?? '', String(workspaceId ?? 'none')),
    queryFn: async () => parseProducts(await api.getProductDrawer()),
    enabled: enabled && Boolean(userId),
    staleTime: 5 * 60 * 1000,
  })
}
